// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3MDU8","upload":"Small_upload___r3Vt","imageWrap":"Small_imageWrap__1R794","removeBtn":"Small_removeBtn__3J83R"};